export default __webpack_public_path__ + "static/media/info-circle.b5f09350.svg";